/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function TextBolder(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M170.4834,115.70117A43.98012,43.98012,0,0,0,140.00049,40l-76.00586-.00488h-.00049a7.99955,7.99955,0,0,0-8,8v152a8,8,0,0,0,7.99951,8L152,208a48.00015,48.00015,0,0,0,18.4834-92.29883ZM71.99414,55.99561,140,56a28,28,0,0,1,0,56H71.99414ZM152.00049,192l-80.00635-.00439V128H152a32,32,0,0,1,.00049,64Z" />
    </Svg>
  );
}

export default TextBolder;
